:host{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;z-index:100}:host.with-overlay{background-color:#ffffff4d}
/*# sourceMappingURL=page-loading-overlay.component.css.map */
